import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'

import { Box, Button, Dialog, Grid, Tooltip, useTheme } from '@mui/material'
import { Add, Print } from '@mui/icons-material'

import { useGET_groupCourseSessionBehaviourQuery, usePOST_groupCourseSessionBehaviourMutation } from 'redux/api/sessionsApi'
import { useGET_studentsQuery } from 'redux/api/studentsApi'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import SessionBehaviourItemList from 'components/molecules/SessionBehaviourItemList'

import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import formModel, { validationSchema } from 'utils/formModels/sessionBehaviourModel'
import { crudColorMap, crudIconMap, printDiv}  from 'utils/helpers'

import { ILessonPlan, ISession } from 'types'
import LessonPlanTemplate from './LessonPlanTemplate'
import LessonPlanForm from 'components/organisms/forms/LessonPlanForm'

interface IProps {
  plan: ILessonPlan
  session: ISession
  tabText?: string
  tabKey?: string
}


const LessonPlanTab: FC<IProps> = ({ plan, session }) => {
  const { t } = useTranslation()
   
  return ( <>
      {session && <LessonPlanForm 
        action={plan ? 'edit' : 'add'} 
        id={plan ? plan.id.toString() : null} 
        sessionId={session.id.toString()} 
        viewOnly={!!(plan && plan.id)}
        /> }
    </>
  )
}
export default LessonPlanTab
